import React from 'react';

const AdminSupportPage: React.FC = () => (
    <div className="p-6">
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-900">Support</h2>
            <div className="mt-6 grid gap-4 md:grid-cols-3">
                <div className="rounded-lg bg-gray-50 p-4">
                    <div className="text-sm font-medium text-gray-500">Open Tickets</div>
                    <div className="mt-2 text-2xl font-semibold text-gray-900">0</div>
                </div>
                <div className="rounded-lg bg-gray-50 p-4">
                    <div className="text-sm font-medium text-gray-500">Escalations</div>
                    <div className="mt-2 text-2xl font-semibold text-gray-900">0</div>
                </div>
                <div className="rounded-lg bg-gray-50 p-4">
                    <div className="text-sm font-medium text-gray-500">SLA Breaches</div>
                    <div className="mt-2 text-2xl font-semibold text-gray-900">0</div>
                </div>
            </div>
        </div>
    </div>
);

export default AdminSupportPage;
